import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppDeployment } from '@atlassian/mpac-types';
import { AtlassianProductHostingType, MarketplaceProgramStatus } from '@atlassian/mpac-types/graphql-gateway-types';
import { MarketplaceAppUtils } from '@atlassian/mpac-utils';
import { getSelectedAppVersion, getSelectedAppVersionConnection } from '../../utils';
const makeWatcherInfo = info => {
  var _info$isUserWatchingA, _info$watchersCount;
  return {
    isUserWatchingApp: (_info$isUserWatchingA = info === null || info === void 0 ? void 0 : info.isUserWatchingApp) !== null && _info$isUserWatchingA !== void 0 ? _info$isUserWatchingA : false,
    watchersCount: (_info$watchersCount = info === null || info === void 0 ? void 0 : info.watchersCount) !== null && _info$watchersCount !== void 0 ? _info$watchersCount : 0
  };
};
export function makeHighlight(highlight, makeImageLink) {
  const {
    croppedScreenshot,
    title,
    summary,
    screenshot
  } = highlight;
  const croppedImage = croppedScreenshot.highResolution || croppedScreenshot.original;
  const image = screenshot.image.highResolution || screenshot.image.original;
  const caption = highlight.caption || screenshot.caption;
  return {
    title,
    caption,
    summary,
    croppedImage: {
      width: croppedImage.width,
      height: croppedImage.height,
      url: makeImageLink(croppedImage.id)
    },
    image: {
      width: image.width,
      height: image.height,
      url: makeImageLink(image.id)
    }
  };
}
export function makeScreenshot(screenshot, makeImageLink) {
  const {
    caption,
    image
  } = screenshot;
  const {
    id,
    width,
    height
  } = image.original;
  return {
    caption,
    image: {
      url: makeImageLink(id),
      width,
      height
    }
  };
}
const makeHeroImage = (heroImage, makeImageLink) => {
  const image = (heroImage === null || heroImage === void 0 ? void 0 : heroImage.highResolution) || (heroImage === null || heroImage === void 0 ? void 0 : heroImage.original);
  if (!image) {
    return null;
  }
  return {
    width: image.width,
    height: image.height,
    url: makeImageLink(image.id)
  };
};
export const makePartner = (partner, detailsLink, makeImageLink) => {
  var _partner$logo$highRes, _partner$programs, _partner$support, _partner$support$cont, _partner$partnerTier;
  const logo = partner !== null && partner !== void 0 && partner.logo && makeImageLink ? makeImageLink(((_partner$logo$highRes = partner.logo.highResolution) === null || _partner$logo$highRes === void 0 ? void 0 : _partner$logo$highRes.id) || partner.logo.original.id) : null;
  return {
    name: partner === null || partner === void 0 ? void 0 : partner.name,
    url: partner ? detailsLink.expand({
      id: partner.id,
      slug: partner.slug
    }) : null,
    programs: {
      isCloudAppSecuritySelfAssessmentDone: (partner === null || partner === void 0 ? void 0 : (_partner$programs = partner.programs) === null || _partner$programs === void 0 ? void 0 : _partner$programs.isCloudAppSecuritySelfAssessmentDone) || false
    },
    support: {
      url: partner === null || partner === void 0 ? void 0 : (_partner$support = partner.support) === null || _partner$support === void 0 ? void 0 : (_partner$support$cont = _partner$support.contactDetails) === null || _partner$support$cont === void 0 ? void 0 : _partner$support$cont.websiteUrl
    },
    partnerType: partner === null || partner === void 0 ? void 0 : partner.partnerType,
    partnerTierType: partner === null || partner === void 0 ? void 0 : (_partner$partnerTier = partner.partnerTier) === null || _partner$partnerTier === void 0 ? void 0 : _partner$partnerTier.type,
    logo
  };
};
export const makePrograms = programs => {
  var _programs$cloudFortif, _programs$bugBountyPa, _programs$bugBountyPa2, _programs$bugBountyPa3, _programs$bugBountyPa4, _programs$bugBountyPa5, _programs$bugBountyPa6;
  return {
    cloudFortified: {
      isStatusApproved: (programs === null || programs === void 0 ? void 0 : (_programs$cloudFortif = programs.cloudFortified) === null || _programs$cloudFortif === void 0 ? void 0 : _programs$cloudFortif.programStatus) === MarketplaceProgramStatus.Approved
    },
    bugBountyParticipant: {
      cloud: {
        status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa = programs.bugBountyParticipant) === null || _programs$bugBountyPa === void 0 ? void 0 : (_programs$bugBountyPa2 = _programs$bugBountyPa.cloud) === null || _programs$bugBountyPa2 === void 0 ? void 0 : _programs$bugBountyPa2.status
      },
      server: {
        status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa3 = programs.bugBountyParticipant) === null || _programs$bugBountyPa3 === void 0 ? void 0 : (_programs$bugBountyPa4 = _programs$bugBountyPa3.server) === null || _programs$bugBountyPa4 === void 0 ? void 0 : _programs$bugBountyPa4.status
      },
      dataCenter: {
        status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa5 = programs.bugBountyParticipant) === null || _programs$bugBountyPa5 === void 0 ? void 0 : (_programs$bugBountyPa6 = _programs$bugBountyPa5.dataCenter) === null || _programs$bugBountyPa6 === void 0 ? void 0 : _programs$bugBountyPa6.status
      }
    }
  };
};
export const makeReviewSummary = summary => {
  var _summary$count, _summary$rating;
  return {
    count: (_summary$count = summary === null || summary === void 0 ? void 0 : summary.count) !== null && _summary$count !== void 0 ? _summary$count : 0,
    rating: (_summary$rating = summary === null || summary === void 0 ? void 0 : summary.rating) !== null && _summary$rating !== void 0 ? _summary$rating : 0
  };
};
export const makeSupportDetails = _ref => {
  var _partner$support2, _partner$support2$con, _partner$support3, _partner$support3$con, _partner$support4, _partner$support4$con, _partner$support5;
  let {
    selectedAppVersion,
    appDetails
  } = _ref;
  const {
    wikiUrl,
    forumsUrl,
    partner,
    issueTrackerUrl,
    supportTicketSystemUrl,
    statusPageUrl
  } = appDetails;
  const {
    documentationUrl
  } = selectedAppVersion || {};
  const resources = {
    documentationUrl,
    wikiUrl,
    forumsUrl
  };
  const isSupported = (selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.isSupported) === true;
  return {
    isSupported,
    isAtlassianCommunityEnabled: appDetails.isAtlassianCommunityEnabled || !isSupported,
    hasResources: Object.values(resources).some(url => !!url),
    resources,
    contact: {
      emailId: partner === null || partner === void 0 ? void 0 : (_partner$support2 = partner.support) === null || _partner$support2 === void 0 ? void 0 : (_partner$support2$con = _partner$support2.contactDetails) === null || _partner$support2$con === void 0 ? void 0 : _partner$support2$con.emailId,
      websiteUrl: partner === null || partner === void 0 ? void 0 : (_partner$support3 = partner.support) === null || _partner$support3 === void 0 ? void 0 : (_partner$support3$con = _partner$support3.contactDetails) === null || _partner$support3$con === void 0 ? void 0 : _partner$support3$con.websiteUrl,
      phoneNumber: partner === null || partner === void 0 ? void 0 : (_partner$support4 = partner.support) === null || _partner$support4 === void 0 ? void 0 : (_partner$support4$con = _partner$support4.contactDetails) === null || _partner$support4$con === void 0 ? void 0 : _partner$support4$con.phoneNumber,
      // support requests
      issueTrackerUrl,
      supportTicketSystemUrl,
      statusPageUrl
    },
    availability: partner === null || partner === void 0 ? void 0 : (_partner$support5 = partner.support) === null || _partner$support5 === void 0 ? void 0 : _partner$support5.availability,
    partner: {
      name: partner === null || partner === void 0 ? void 0 : partner.name
    }
  };
};
export const hasDownloadableArtifact = (deployment, hosting) => {
  if (!deployment) return false;
  const cloudPreinstalled = hosting === AtlassianProductHostingType.Cloud && deployment.__typename === AppDeployment.PLUGINS2;
  if (deployment.__typename === AppDeployment.INSTRUCTIONAL) {
    return deployment.isBinaryUrlAvailable;
  } else if (deployment.__typename === AppDeployment.WORKFLOW) {
    return deployment.isWorkflowDataFileAvailable;
  } else {
    return !MarketplaceAppUtils.isRemoteable(deployment) && !cloudPreinstalled;
  }
};
const makeInstallationInstructions = _ref2 => {
  var _selectedAppVersion$d;
  let {
    selectedAppVersion,
    makeMediaImage
  } = _ref2;
  if (selectedAppVersion && selectedAppVersion.deployment.__typename === AppDeployment.INSTRUCTIONAL && (_selectedAppVersion$d = selectedAppVersion.deployment.instructions) !== null && _selectedAppVersion$d !== void 0 && _selectedAppVersion$d.length) {
    const {
      instructions
    } = selectedAppVersion.deployment;
    return instructions.map(_ref3 => {
      var _screenshot$highResol;
      let {
        instruction,
        screenshot
      } = _ref3;
      const screenshotImage = (_screenshot$highResol = screenshot === null || screenshot === void 0 ? void 0 : screenshot.highResolution) !== null && _screenshot$highResol !== void 0 ? _screenshot$highResol : screenshot === null || screenshot === void 0 ? void 0 : screenshot.original;
      return {
        instruction,
        screenshot: screenshotImage !== null && screenshotImage !== void 0 && screenshotImage.id ? {
          url: makeMediaImage(screenshotImage.id),
          width: screenshotImage.width,
          height: screenshotImage.height
        } : null
      };
    });
  }
  return [];
};
const makeResourceLinks = _ref4 => {
  let {
    appDetails,
    latestVersion,
    appVersionHistoryLink,
    artifactDownloadLink,
    descriptorDownloadLink,
    hosting
  } = _ref4;
  const {
    appId,
    slug
  } = appDetails;
  const {
    deployment,
    buildNumber,
    endUserLicenseAgreementUrl,
    learnMoreUrl,
    documentationUrl,
    purchaseUrl
  } = latestVersion || {};
  return {
    endUserLicenseAgreementUrl,
    learnMoreUrl,
    documentationUrl,
    purchaseUrl,
    versionHistoryUrl: appVersionHistoryLink.expand({
      appId,
      appSlug: slug
    }),
    artifactDownloadUrl: hasDownloadableArtifact(deployment, hosting) ? artifactDownloadLink.expand({
      appId,
      buildNumber
    }) : undefined,
    descriptorDownloadUrl: (deployment === null || deployment === void 0 ? void 0 : deployment.__typename) === AppDeployment.CONNECT ? descriptorDownloadLink.expand({
      appId,
      buildNumber
    }) : undefined
  };
};
const makeAppScopes = latestVersion => {
  if (latestVersion && latestVersion.deployment && (latestVersion.deployment.__typename === AppDeployment.CONNECT || latestVersion.deployment.__typename === AppDeployment.ECOSYSTEM_CLOUD)) {
    return latestVersion.deployment.scopes;
  }
  return [];
};
export const makeDistribution = (distribution, hosting) => {
  var _distribution$downloa, _distribution$install;
  const preInstalledInSelectedHosting = hosting === AtlassianProductHostingType.Cloud ? distribution === null || distribution === void 0 ? void 0 : distribution.isPreinstalledInCloud : distribution === null || distribution === void 0 ? void 0 : distribution.isPreinstalledInServerDC;
  return {
    downloadCount: (_distribution$downloa = distribution === null || distribution === void 0 ? void 0 : distribution.downloadCount) !== null && _distribution$downloa !== void 0 ? _distribution$downloa : 0,
    installationCount: (_distribution$install = distribution === null || distribution === void 0 ? void 0 : distribution.installationCount) !== null && _distribution$install !== void 0 ? _distribution$install : 0,
    isPreinstalled: preInstalledInSelectedHosting || false,
    isPreinstalledInAnyHosting: (distribution === null || distribution === void 0 ? void 0 : distribution.isPreinstalledInCloud) || (distribution === null || distribution === void 0 ? void 0 : distribution.isPreinstalledInServerDC) || false
  };
};
export default function transformAppListing(args) {
  var _appDetails$serverApp, _appDetails$serverApp2, _appDetails$cloudAppV, _appDetails$cloudAppV2, _appDetails$dataCente, _appDetails$dataCente2, _appDetails$logo$high, _appDetails$logo$high2, _highlights$map, _screenshots$map, _appDetails$tagline, _appDetails$summary, _selectedAppVersionCo, _deployment$compatibl;
  const {
    appDetails,
    mediaImageLink,
    partnerDetailsLink,
    hosting,
    appVersionHistoryLink,
    artifactDownloadLink,
    descriptorDownloadLink,
    appIconLink
  } = args;
  const selectedAppVersion = getSelectedAppVersion(hosting, appDetails);
  const selectedAppVersionConnection = getSelectedAppVersionConnection(hosting, appDetails);
  const latestServerAppVersion = (_appDetails$serverApp = appDetails.serverAppVersions.edges) === null || _appDetails$serverApp === void 0 ? void 0 : (_appDetails$serverApp2 = _appDetails$serverApp[0]) === null || _appDetails$serverApp2 === void 0 ? void 0 : _appDetails$serverApp2.node;
  const latestCloudAppVersion = (_appDetails$cloudAppV = appDetails.cloudAppVersions.edges) === null || _appDetails$cloudAppV === void 0 ? void 0 : (_appDetails$cloudAppV2 = _appDetails$cloudAppV[0]) === null || _appDetails$cloudAppV2 === void 0 ? void 0 : _appDetails$cloudAppV2.node;
  const latestDataCenterAppVersion = (_appDetails$dataCente = appDetails.dataCenterAppVersions.edges) === null || _appDetails$dataCente === void 0 ? void 0 : (_appDetails$dataCente2 = _appDetails$dataCente[0]) === null || _appDetails$dataCente2 === void 0 ? void 0 : _appDetails$dataCente2.node;

  // for all UX purposes, cloud only has 1 version from a user’s POV
  const totalVersionCount = Math.min(1, appDetails.cloudAppVersions.totalCount) + appDetails.serverAppVersions.totalCount + appDetails.dataCenterAppVersions.totalCount;
  const serverCompatibleProducts = (latestServerAppVersion === null || latestServerAppVersion === void 0 ? void 0 : latestServerAppVersion.deployment.compatibleProducts) || [];
  const cloudCompatibleProducts = (latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : latestCloudAppVersion.deployment.compatibleProducts) || [];
  const dataCenterCompatibleProducts = (latestDataCenterAppVersion === null || latestDataCenterAppVersion === void 0 ? void 0 : latestDataCenterAppVersion.deployment.compatibleProducts) || [];
  const makeMediaImage = imageId => mediaImageLink.expand({
    imageId
  });
  const {
    name,
    appKey,
    appId,
    slug,
    privacyPolicyUrl,
    partner,
    programs
  } = appDetails;
  const {
    youtubeId,
    highlights,
    screenshots,
    moreDetails,
    heroImage,
    deployment,
    releaseDate,
    releaseNotes,
    releaseSummary,
    releaseNotesUrl,
    version
  } = selectedAppVersion || {};
  const appScopes = makeAppScopes(selectedAppVersion);
  const logo = appDetails.logo ? makeMediaImage((_appDetails$logo$high = (_appDetails$logo$high2 = appDetails.logo.highResolution) === null || _appDetails$logo$high2 === void 0 ? void 0 : _appDetails$logo$high2.id) !== null && _appDetails$logo$high !== void 0 ? _appDetails$logo$high : appDetails.logo.original.id) : appIconLink.expand({
    appKey
  });
  return _objectSpread(_objectSpread({
    appId,
    appKey,
    slug,
    heroImage: makeHeroImage(heroImage, makeMediaImage),
    logo,
    highlights: (_highlights$map = highlights === null || highlights === void 0 ? void 0 : highlights.map(highlight => makeHighlight(highlight, makeMediaImage))) !== null && _highlights$map !== void 0 ? _highlights$map : [],
    moreDetails,
    name,
    partner: makePartner(partner, partnerDetailsLink, makeMediaImage),
    privacyPolicyUrl,
    screenshots: (_screenshots$map = screenshots === null || screenshots === void 0 ? void 0 : screenshots.map(screenshot => makeScreenshot(screenshot, makeMediaImage))) !== null && _screenshots$map !== void 0 ? _screenshots$map : [],
    tagline: (_appDetails$tagline = appDetails.tagline) !== null && _appDetails$tagline !== void 0 ? _appDetails$tagline : '',
    // Tagline is mandatory in the app details form, but historically some apps don't have it
    summary: (_appDetails$summary = appDetails.summary) !== null && _appDetails$summary !== void 0 ? _appDetails$summary : '',
    // Summary is mandatory in the app details form, but historically some apps don't have it
    youtubeId,
    marketingLabels: appDetails.marketingLabels,
    categories: appDetails.categories.map(category => ({
      name: category.name
    })),
    reviewSummary: makeReviewSummary(appDetails.reviewSummary),
    watchersInfo: makeWatcherInfo(appDetails.watchersInfo),
    productHostingOptions: appDetails.productHostingOptions,
    appScopes,
    listingStatus: appDetails.listingStatus,
    releaseDate,
    releaseNotes,
    releaseSummary,
    releaseNotesUrl,
    serverCompatibleProducts,
    cloudCompatibleProducts,
    dataCenterCompatibleProducts,
    versionCount: (_selectedAppVersionCo = selectedAppVersionConnection.totalCount) !== null && _selectedAppVersionCo !== void 0 ? _selectedAppVersionCo : 0,
    totalVersionCount,
    version,
    hasDataCenterVersion: !!appDetails.dataCenterAppVersions.totalCount,
    compatibleProducts: (_deployment$compatibl = deployment === null || deployment === void 0 ? void 0 : deployment.compatibleProducts) !== null && _deployment$compatibl !== void 0 ? _deployment$compatibl : [],
    supportDetails: makeSupportDetails({
      appDetails,
      selectedAppVersion,
      hosting
    })
  }, makeResourceLinks({
    appDetails,
    latestVersion: selectedAppVersion,
    appVersionHistoryLink,
    artifactDownloadLink,
    descriptorDownloadLink,
    hosting
  })), {}, {
    createdAt: new Date(appDetails.createdAt),
    distribution: makeDistribution(appDetails.distribution, hosting),
    installationInstructions: makeInstallationInstructions({
      selectedAppVersion,
      makeMediaImage
    }),
    deploymentType: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.deployment.__typename,
    paymentModel: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.paymentModel,
    programs: makePrograms(programs)
  });
}